<!-- Loaders -->
<app-loading-spinner *ngIf="!storeFetched"></app-loading-spinner>

<!-- Main store view -->
<section
  appScrollToTop
  *ngIf="storeResponse && storeFetched && !storeNotFound"
  class="bg-[#FBFBFB] font-mont"
>
  <!-- Header -->
  <app-header type="hero"
    *ngIf="!deactivated"
    [storeName]="storeResponse"
    (filterWithPrice)="filterWithPrice($event)"
    (searchTermChanged)="filterAndSearchProduct($event)"
  ></app-header>

  <main class="px-1 mx-0 my-8 rounded lg:mx-20 mt-[6rem]">

    <!-- Search / filter bar (mobile) -->
    <div class="py-6 block lg:flex justify-between items-center">
      <div *ngIf="productSearch" class="flex items-center px-0 pb-3 lg:pb-0">
        <img
          src="../../../assets/svg/back.svg"
          alt="back"
          class="cursor-pointer"
          (click)="reset()"
        />
        <p class="hidden lg:block font-medium text-zestBlack text-lg pl-4">Back</p>
      </div>

      <div class="md:hidden flex w-full justify-end">
        <div class="relative w-3/4 xl:w-fit md:mr-2 xl:mr-0">
          <input
            type="text"
            placeholder="Search by product name"
            (change)="filterAndSearchProduct($event)"
            class="w-full text-sm sm:pr-5 mr-3 focus:border-zestGreen focus:ring-zestGreen sm:pl-4 border-[#C1C7D0] rounded py-3 xl:px-4 font-mont lg:text-base xl:w-[377px]"
          />
          <img
            src="../../../assets/svg/Search.svg"
            alt="search"
            class="absolute w-4 h-4 right-2 xl:right-5 bottom-4 mr-1 xl:mr-4"
          />
        </div>

        <select
          (change)="filterWithPrice($event)"
          class="hidden md:block bg-white w-1/6 md:w-1/4 xl:w-1/6 outline-hidden rounded border text-sm lg:text-base placeholder-zestPlaceholder border-solid border-[#c1c7d0] px-4 py-3 focus:border-zestGreen focus:ring-zestGreen"
        >
          <option *ngFor="let option of options">{{ option }}</option>
        </select>

        <div class="block md:hidden w-1/4 ml-2">
          <button
            (click)="openFilter()"
            class="border border-zestPlaceholder relative text-sm lg:text-base text-zestGrey rounded py-3 px-4"
          >
            <div class="flex justify-center items-center">
              <p class="pr-2">Filter</p>
              <img src="../../../assets/svg/equalizerline.svg" alt="equalizer" />
            </div>
          </button>
          <div
            *ngIf="filter"
            class="z-10 absolute bg-white rounded border border-zestNeutral w-1.5/6 right-6 mt-5 p-4 shadow transition-all"
          >
            <select
              (change)="filterWithPrice($event)"
              class="bg-white text-sm w-full outline-hidden rounded border placeholder-zestPlaceholder border-solid border-[#c1c7d0] px-4 py-3 focus:border-zestGreen focus:ring-zestGreen"
            >
              <option *ngFor="let option of options">{{ option }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <!-- Products or empty state -->
     @if (productFetched) {
      @if (products && products.length > 0) {
        <app-product-grid
        [products]="products"
        [storeName]="singleStore.storename"
        [currentPage]="store.currentPage"
        [totalItems]="totalItems"
        [totalElements]="totalElements"
        [lastPage]="lastpage"
        [cart]="cart"
        (pageChanged)="changePage($event)"
        (addToCart)="addToCart($event)"
      ></app-product-grid>
      } @else{
        <app-empty-store [storeActive]="storeResponse?.active"></app-empty-store>
      }
     } @else {
       <div class="flex justify-center items-center py-20">
         <app-loading-spinner></app-loading-spinner>
       </div>
     }

  </main>

  <!-- Reviews -->
  <section class="sm:mx-5 px-5 lg:mx-[154px]">
    <app-reviews [rating]="storeResponse"></app-reviews>
  </section>

  <!-- Footer -->
  <section class="my-8 px-4 lg:px-40 bg-[#F4F6F9]">
    <app-footer [storeName]="storeResponse"></app-footer>
  </section>
</section>

<!-- Store not found -->
<div *ngIf="!deactivated && storeFetched && productFetched && storeNotFound">
  <div class="flex justify-center items-center shadow-sm bg-red-700 font-semibold text-white">
    <p class="text-center py-5">
      An error occurred while fetching store information.
      <span class="block">Please, check the store url and try again.</span>
    </p>
  </div>
</div>
